import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import UserInfo from "../UserInfo";
import { Button } from "devextreme-react";
import apiAxios from "../api-axios";

const template = {
  prefeituraId: UserInfo.getPrefeitura(),
  duracao: 0,
  intervaloNotificacao: 0,
  situacao: 1,
  tipoResultado: 0,
  msg: null,
};

export default class CadastroProcessamentosTeste extends React.Component {
  constructor(props) {
    super(props);
    console.log(this);
    this.ok = this.ok.bind(this);
    this.state = { ...template };

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: 1, descricao: "Sucesso" },
        { id: 2, descricao: "Alerta" },
        { id: 3, descricao: "Erro" },
        { id: 4, descricao: "Cancelado" },
        { id: 5, descricao: "Ignorado" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.resultadoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: 0, descricao: "OK" },
        { id: 1, descricao: "Arquivo" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3> CRIAR PROCESSAMENTO</h3>
        <Form formData={this.state} colCount={2} labelLocation={"top"}>
          <GroupItem colSpan={2} colCount={4}>
            <SimpleItem
              dataField={"duracao"}
              colSpan={1}
              editorType={"dxNumberBox"}
              editorOptions={{ step: 0, value: null }}
            >
              <Label text="Duração do Processamento" />
            </SimpleItem>
            <SimpleItem
              dataField={"intervaloNotificacao"}
              colSpan={1}
              editorType={"dxNumberBox"}
              editorOptions={{ step: 0, value: null }}
            >
              <Label text="Intervalo da Notificação" />
            </SimpleItem>
            <SimpleItem
              dataField={"situacao"}
              editorType={"dxLookup"}
              editorOptions={this.situacaoOptions}
              colSpan={1}
            >
              <Label text="Situação" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoResultado"}
              editorType={"dxLookup"}
              editorOptions={this.resultadoOptions}
              colSpan={1}
            >
              <Label text="Tipo de Resultado" />
            </SimpleItem>
            <SimpleItem
              dataField={"msg"}
              editorType={"dxTextArea"}
              editorOptions={{ height: "100px" }}
              colSpan={4}
            >
              <Label text="Mensagem" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <br></br>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
          }}
        >
          <div style={{ display: "inline-block" }}>
            <Button
              width={200}
              text="Enviar Processamento"
              type="success"
              onClick={this.ok}
            />
          </div>
        </div>
      </div>
    );
  }
  ok() {
    apiAxios
      .post("processamentos/criar_teste", { ...this.state })
      .then((response) => {
        if (response.status === 200) {
          console.log(response);
          this.props.history.push(
            `/acompanharprocessamento/${response.data.processamentoId}`
          );
        } else {
          notify(response.statusText, "error", 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
